module.exports = __webpack_public_path__ + "0674416d4f0f0753850c6ddbe6b2bd7d.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold.woff
// module id = 405
// module chunks = 0